import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FloatLabel from "../../UiComponents/FloatLabel/FloatLabel";
import { Formik, Form, Field, FieldArray } from "formik";
import {
  PostClient,
  UpdateClient,
  RegisterService,
} from "../../Service/_index";
import CloseIcon from "@mui/icons-material/Close";
import { ToastSuccess } from "../../UiComponents/Toaster/Toast";
import { Box, Button, Divider, Stack, IconButton } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router-dom";
import Styles from "./Client.module.scss";
import {
  AddIcon,
  VisibilityIcon,
  VisibilityOffIcon,
  DeleteIcon,
} from "../../Resources/Icons/icons";

import * as Yup from "yup";
import { PROVIDER_COMPANIES } from "../../Shared/CommonConstant";
import { GetProviderCredentials } from "../../Service/UserService";

const AddClient = (props) => {
  const { selectedData, formType, setOpenDrawer, title, GetData } = props;
  let formRef = useRef();
  const navigate = useNavigate();
  const roleId = sessionStorage.getItem("roleId");

  const availableCompanies = PROVIDER_COMPANIES;

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showOPPassword, setShowOPPassword] = useState(false);

  const initialValues = {
    name: "",
    email: "",
    mobileNumber: "",
    password: "",
    confirmPassword: "",
    providerCredentials: [
      {
        companyName: "",
        onlinePolicyUserName: "",
        onlinePolicyPassword: "",
        onlinePolicyLoginUrl: "",
      },
    ],
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    mobileNumber: Yup.string().required("Mobile number is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm password is required"),
    providerCredentials: Yup.array().of(
      Yup.object().shape({
        companyName: Yup.string().required("Company Name is required"),
        onlinePolicyUserName: Yup.string().required("User Name is required"),
        onlinePolicyPassword: Yup.string().required("Password is required"),
      })
    ),
  });

  useEffect(() => {
    if (formType === "edit") {
      const editValues = { ...initialValues };
      Object.keys(initialValues).forEach((el) => {
        if (el !== "providerCredentials") {
          editValues[el] = selectedData[el] || "";
        }
      });
      
      // Handle Provider Credentials. The copy on the client document is only a
      // fallback now — editing credentials through Profile → Account & Policy
      // Settings clears it, and the ProviderCredential collection is the real
      // home. The authoritative list is fetched after setValues below.
      if (selectedData.providerCredentials && selectedData.providerCredentials.length > 0) {
        editValues.providerCredentials = selectedData.providerCredentials.map(pc => ({
          companyName: pc.companyName || "",
          onlinePolicyUserName: pc.onlinePolicyUserName || "",
          onlinePolicyPassword: pc.onlinePolicyPassword || "",
          onlinePolicyLoginUrl: pc.onlinePolicyLoginUrl || "",
        }));
      } else if (selectedData.companyName) {
        // Fallback for legacy data
        editValues.providerCredentials = [{
          companyName: selectedData.companyName,
          onlinePolicyUserName: selectedData.onlinePolicyUserName || "",
          onlinePolicyPassword: selectedData.onlinePolicyPassword || "",
          onlinePolicyLoginUrl: selectedData.onlinePolicyLoginUrl || "",
        }];
      }

      if (selectedData.client && !selectedData.name) {
        editValues.name = selectedData.client;
      }
      editValues.confirmPassword = selectedData.password || "";

      if (formRef.current) {
        formRef.current.setValues(editValues);
      }

      // Fired after setValues on purpose — setValues replaces the whole form,
      // so a fetch that resolved first would be overwritten by it.
      if (selectedData?._id) {
        GetProviderCredentials(selectedData._id).then((creds) => {
          if (creds.length > 0 && formRef.current) {
            formRef.current.setFieldValue("providerCredentials", creds);
          }
        });
      }
    } else {
      if (formRef.current) {
        formRef.current.setValues(initialValues);
      }
    }
  }, [formType, selectedData]);

  const onSubmit = (data) => {
    const payload = { ...data };
    delete payload.confirmPassword; // Remove frontend-only field
    // isNew only marks a set added on this screen (so it can be removed before saving) - never sent
    if (Array.isArray(payload.providerCredentials)) {
      payload.providerCredentials = payload.providerCredentials.map(({ isNew, ...cred }) => cred);
    }

    let SubmitType =
      formType === "edit"
        ? UpdateClient(selectedData._id, payload)
        : RegisterService(payload);
    SubmitType.then((res) => {
      GetData();
      setOpenDrawer(false);
      ToastSuccess(
        formType === "edit"
          ? "Client Updated Successfully"
          : "Client Created Successfully"
      );
    }).catch((error) => {
      console.log(error);
    });
  };

  const triggerSubmit = () => {
    if (formRef.current) {
      formRef.current.submitForm();
    }
  };

  return (
    <>
      <div className={Styles.MainRenderinContainer}>
        <Stack direction={"row"} alignItems={"center"}>
          <div className="breadcrumb" style={{ marginLeft: "33px" }}>
            <span
              className="text-color"
              onClick={() => {
                navigate("/dashboard");
              }}
              style={{ cursor: "pointer" }}
            >
              {"Terminal"}
            </span>
            <span style={{ padding: "0px 10px" }}>
              <ArrowForwardIosIcon style={{ fontSize: "13px" }} />
            </span>
            <span
              className="text-color"
              onClick={() => {
                setOpenDrawer(false);
              }}
              style={{ cursor: "pointer" }}
            >
              {"Client"}
            </span>
            <span style={{ padding: "0px 10px" }}>
              <ArrowForwardIosIcon style={{ fontSize: "13px" }} />
            </span>
            <span className="text-color">{title} Client</span>
          </div>
        </Stack>

        <div className={Styles.formContainer}>
          <Grid
            container
            className="Master_Card_Container"
            sx={{ border: "none" }}
          >
            <Grid
              container
              alignItems={"center"}
              className="Master_Card_Sub_Container"
            >
              <Grid item xs={12} sm={6}>
                <Typography className="Master_Card_Tittle">
                  {title} Client
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                className="d-flex justify-content-end"
                gap={2}
              >
                <Button
                  className="Master_Card_create_Button"
                  sx={{ width: "100px !important" }}
                  startIcon={<AddIcon />}
                  onClick={triggerSubmit}
                >
                  {formType === "edit" ? "Update" : "Create"}
                </Button>
                <CloseIcon
                  onClick={() => setOpenDrawer(false)}
                  sx={{ cursor: "pointer", mt: 1 }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Divider sx={{ backgroundColor: "#EAECF0", borderWidth: 1 }} />
            </Grid>
          </Grid>

          <Box className={Styles.formContent}>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                onSubmit(values);
              }}
              innerRef={(ref) => {
                if (ref) {
                  formRef.current = ref;
                }
              }}
            >
              {({ values, errors, touched }) => (
                <Form>
                  <Box className={Styles.addContent}>
                    <Typography mt={3} className={Styles.formTitleHead}>
                      Personal Details
                    </Typography>
                    <Grid container spacing={3} mt={0.5}>
                      <Grid item xs={12} sm={4}>
                        <FloatLabel label="Client Name" value={values.name}>
                          <Field name="name" className="InputFiled" />
                        </FloatLabel>
                        {errors.name && touched.name && (
                          <div style={{ color: "red", fontSize: "12px" }}>
                            {errors.name}
                          </div>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FloatLabel
                          label="Mobile Number"
                          value={values.mobileNumber}
                        >
                          <Field name="mobileNumber" className="InputFiled" />
                        </FloatLabel>
                        {errors.mobileNumber && touched.mobileNumber && (
                          <div style={{ color: "red", fontSize: "12px" }}>
                            {errors.mobileNumber}
                          </div>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FloatLabel label="Email" value={values.email}>
                          <Field name="email" className="InputFiled" />
                        </FloatLabel>
                        {errors.email && touched.email && (
                          <div style={{ color: "red", fontSize: "12px" }}>
                            {errors.email}
                          </div>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FloatLabel label="Password" value={values.password}>
                          <Box sx={{ position: "relative" }}>
                            <Field
                              name="password"
                              className="InputFiled"
                              type={showPassword ? "text" : "password"}
                            />
                            <IconButton
                              onClick={() => setShowPassword(!showPassword)}
                              sx={{ position: "absolute", right: 8, top: "5px" }}
                              size="small"
                            >
                              {showPassword ? (
                                <VisibilityOffIcon sx={{ fontSize: "20px" }} />
                              ) : (
                                <VisibilityIcon sx={{ fontSize: "20px" }} />
                              )}
                            </IconButton>
                          </Box>
                        </FloatLabel>
                        {errors.password && touched.password && (
                          <div style={{ color: "red", fontSize: "12px" }}>
                            {errors.password}
                          </div>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FloatLabel
                          label="Confirm Password"
                          value={values.confirmPassword}
                        >
                          <Box sx={{ position: "relative" }}>
                            <Field
                              name="confirmPassword"
                              className="InputFiled"
                              type={showConfirmPassword ? "text" : "password"}
                            />
                            <IconButton
                              onClick={() =>
                                setShowConfirmPassword(!showConfirmPassword)
                              }
                              sx={{ position: "absolute", right: 8, top: "5px" }}
                              size="small"
                            >
                              {showConfirmPassword ? (
                                <VisibilityOffIcon sx={{ fontSize: "20px" }} />
                              ) : (
                                <VisibilityIcon sx={{ fontSize: "20px" }} />
                              )}
                            </IconButton>
                          </Box>
                        </FloatLabel>
                        {errors.confirmPassword && touched.confirmPassword && (
                          <div style={{ color: "red", fontSize: "12px" }}>
                            {errors.confirmPassword}
                          </div>
                        )}
                      </Grid>
                    </Grid>

                    <Typography mt={4} className={Styles.formTitleHead}>
                      Online Policy Credentials
                    </Typography>

                    <FieldArray name="providerCredentials">
                      {({ push, remove }) => (
                        <>
                          {values.providerCredentials.map((cred, index) => (
                            <Box key={index} sx={{ mb: 4, p: 3, border: "1px solid #EAECF0", borderRadius: "12px", position: "relative", backgroundColor: "#F9FAFB" }}>
                              <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                                <Typography sx={{ fontWeight: 600, fontSize: "14px", color: "#1E3A5F" }}>
                                  Policy Credentials Set {index + 1}
                                </Typography>
                                {/* Edit: only a set added on this screen and not saved yet can be removed - saved ones stay */}
                                {(formType === "edit" ? cred.isNew : values.providerCredentials.length > 1) && (
                                  <Button
                                    variant="outlined"
                                    color="error"
                                    size="small"
                                    startIcon={<DeleteIcon />}
                                    onClick={() => remove(index)}
                                    sx={{ textTransform: "none", borderRadius: "8px" }}
                                  >
                                    Remove
                                  </Button>
                                )}
                              </Stack>
                              <Grid container spacing={3}>
                                <Grid item xs={12} sm={4}>
                                  <FloatLabel
                                    label="Company Name"
                                    value={cred.companyName}
                                  >
                                    <Field
                                      name={`providerCredentials.${index}.companyName`}
                                      as="select"
                                      className="InputFiled"
                                    >
                                      <option value=""></option>
                                      {PROVIDER_COMPANIES.map((company) => (
                                        <option key={company} value={company}>
                                          {company}
                                        </option>
                                      ))}
                                    </Field>
                                  </FloatLabel>
                                  {errors.providerCredentials && errors.providerCredentials[index] && errors.providerCredentials[index].companyName && touched.providerCredentials && touched.providerCredentials[index] && touched.providerCredentials[index].companyName && (
                                    <div style={{ color: "red", fontSize: "12px" }}>
                                      {errors.providerCredentials[index].companyName}
                                    </div>
                                  )}
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                  <FloatLabel
                                    label="LogIn URL"
                                    value={cred.onlinePolicyLoginUrl}
                                  >
                                    <Field
                                      name={`providerCredentials.${index}.onlinePolicyLoginUrl`}
                                      className="InputFiled"
                                    />
                                  </FloatLabel>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                  <FloatLabel
                                    label="Online Policy User Name"
                                    value={cred.onlinePolicyUserName}
                                  >
                                    <Field
                                      name={`providerCredentials.${index}.onlinePolicyUserName`}
                                      className="InputFiled"
                                    />
                                  </FloatLabel>
                                  {errors.providerCredentials && errors.providerCredentials[index] && errors.providerCredentials[index].onlinePolicyUserName && touched.providerCredentials && touched.providerCredentials[index] && touched.providerCredentials[index].onlinePolicyUserName && (
                                    <div style={{ color: "red", fontSize: "12px" }}>
                                      {errors.providerCredentials[index].onlinePolicyUserName}
                                    </div>
                                  )}
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                  <FloatLabel
                                    label="Online Policy Password"
                                    value={cred.onlinePolicyPassword}
                                  >
                                    <Box sx={{ position: "relative" }}>
                                      <Field
                                        name={`providerCredentials.${index}.onlinePolicyPassword`}
                                        className="InputFiled"
                                        type={showOPPassword ? "text" : "password"}
                                      />
                                      <IconButton
                                        onClick={() => setShowOPPassword(!showOPPassword)}
                                        sx={{ position: "absolute", right: 8, top: "5px" }}
                                        size="small"
                                      >
                                        {showOPPassword ? (
                                          <VisibilityOffIcon sx={{ fontSize: "20px" }} />
                                        ) : (
                                          <VisibilityIcon sx={{ fontSize: "20px" }} />
                                        )}
                                      </IconButton>
                                    </Box>
                                  </FloatLabel>
                                  {errors.providerCredentials && errors.providerCredentials[index] && errors.providerCredentials[index].onlinePolicyPassword && touched.providerCredentials && touched.providerCredentials[index] && touched.providerCredentials[index].onlinePolicyPassword && (
                                    <div style={{ color: "red", fontSize: "12px" }}>
                                      {errors.providerCredentials[index].onlinePolicyPassword}
                                    </div>
                                  )}
                                </Grid>
                              </Grid>
                            </Box>
                          ))}
                          {values.providerCredentials.length < availableCompanies.length && (
                            <Button
                              startIcon={<AddIcon />}
                              onClick={() => push({ companyName: "", onlinePolicyUserName: "", onlinePolicyPassword: "", onlinePolicyLoginUrl: "", isNew: true })}
                              sx={{ color: "#1E3A5F", textTransform: "none", fontWeight: 600, border: "1px dashed #1E3A5F", py: 1, px: 2 }}
                            >
                              Add Another Company
                            </Button>
                          )}
                        </>
                      )}
                    </FieldArray>
                  </Box>
                </Form>
              )}
            </Formik>
          </Box>
        </div>
      </div>
    </>
  );
};

export default AddClient;

